import { getLatestMessageTimestamp, getIsAssignedToBot } from 'conversations-thread-data/thread-details/public/operators';
const THIRTY_MINUTES_IN_MS = 1800000;
export const isBotConversationWithRecentMessages = threadDetails => {
  const latestMessageTimestamp = getLatestMessageTimestamp(threadDetails);
  const timeSinceLastMessage = Date.now() - latestMessageTimestamp;
  return getIsAssignedToBot(threadDetails) && timeSinceLastMessage < THIRTY_MINUTES_IN_MS;
};